import * as React from 'react';
import { IconButton, makeStyles } from '@material-ui/core';
import { format } from 'date-fns';

import ClockIcon from '../../icons/Clock.icon';
import LanguageIcon from '@material-ui/icons/Language';
import CalendarIcon from '../../icons/Calendar.icon';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import {
  OverviewItemProps,
  OverviewListProps,
  TimeOption
} from '../np-types';

const useItemStyles = makeStyles(() => ({
  root: {
    marginBottom: '20px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    color: 'rgba(0, 0, 0, 0.54)',
    marginBottom: '5px',
    '& svg': {
      marginRight: '5px'
    }
  },
  contents: {
    fontWeight: 'bold'
  },
}));

const OverviewItem = ({ icon = null, title, contents }: OverviewItemProps) => {
  const classes = useItemStyles();
  return (
    <div className={classes.root}>
      <div className={classes.header}>{icon} {title}</div>
      <div className={classes.contents}>{contents}</div>
    </div>
  );
};


export const OverviewList = ({
  date, time, timezone
}: OverviewListProps) => (
  <div>
    <OverviewItem
      icon={<CalendarIcon style={{ height: 20 }} />}
      title="Date & Time"
      contents={format(new Date(date), 'EEE, MMM d, yyyy') + (time ? ` [${time?.display}]` : '')} />

    <OverviewItem
      icon={<LanguageIcon />}
      title="Timezone"
      contents={timezone.replace(/_/g, ' ')} />

    {/*<OverviewItem
      icon={<HourglassEmptyIcon />}
      title="Duration"
      contents={`${duration} minutes`} />*/}
  </div>
);

interface OverviewMobileProps {
  date: Date;
  time: TimeOption;
  timezone: string;
  nav: () => void;
  nppType: 'New' | 'Existing';
}

const useStyles = makeStyles(() => ({
  text: {
    fontSize: '0.8rem',
    color: 'rgba(0,0,0,0.5)',
    marginLeft: '5px'
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  mobileContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '-20px',
    marginBottom: 16,
  },
  buttonAndTitle: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 20,
  },
  dataMargin: {
    marginLeft: 25,
  },
}));

export const OverviewMobile = ({
  date, time, timezone, nav, nppType
}: OverviewMobileProps) => {
  const classes = useStyles();
  return (
    <div className={classes.mobileContainer}>
      <div className={classes.buttonAndTitle}>
        <IconButton onClick={nav}>
          <ArrowBackIcon />
        </IconButton>
        <span><b>{nppType} Patient</b> <i>Scheduling</i></span>
      </div>

      <div className={classes.dataMargin}>
        {time &&
          <div className={classes.textContainer}>
            <ClockIcon style={{ height: 20 }} />
            <span className={classes.text}> {time?.display} </span>
          </div>}

        <div className={classes.textContainer} style={{ marginTop: '10px' }}>
          <CalendarIcon style={{ height: 20 }} />
          <span className={classes.text}>{format(new Date(date), 'EEE, MMM d, yyyy')}  ({timezone.replace(/_/g, ' ')})</span>
        </div>
      </div>
    </div>
  );
};

